import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CustomMessageMiniEntity } from '../../domain/entities/CustomMessageMiniEntity'
import type { CustomMessageAdminDto } from '@/backend/market'

export class CustomMessageMiniModel extends CustomMessageMiniEntity {
 
  constructor(dataDto: CustomMessageAdminDto) {
    super()
    mapEntityProperties<CustomMessageMiniEntity>(this, dataDto)
  }
}
